<app-page [title]="'news.title' | translate">
  <div class="news-container">
    <form [formGroup]="form" class="search-form">
      <motif-form-field>
        <input
          motifInput
          motifSearch
          type="text"
          placeholder="Search for title or keywords"
          aria-label="Search Bar"
          formControlName="search"
          [motifTypeahead]="filteredNotifications"
          [hideClear]="hideClearButton"
          (input)="onSearchInput($event)"
          (clear)="clearValue()" />
        @if (form.get('search')?.hasError('invalidSearch')) {
          <div class="error-message">
            {{ 'news.searchError' | translate }}
          </div>
        }
      </motif-form-field>
    </form>
    <div class="card-container">
      @for (notification of filteredNotifications; track notification) {
        <motif-card orientation="vertical" cardVariant="card-border">
          <div class="card-header">
            <div class="chip-layout">
              <span class="card-title">{{ notification.title }}</span>
              <!-- Conditionally display the "new" chip -->
              @if (isNewNotification(notification.publishedOn)) {
                <div>
                  <motif-chip
                    [removeable]="false"
                    variant="success"
                    chipAriaLabel="New Notification"
                    chipTitle="New Notification"
                    class="chip">
                    NEW!
                  </motif-chip>
                </div>
              }
            </div>
            <div class="motif-card-subheader datetime">
              <motif-icon
                [iconFunction]="myIconFunction()"
                strokeWidth="1"
                stroke="none"
                fill="currentColor"
                size="16"
                title="calender"
                class="calender-icon"
                aria-hidden="true"></motif-icon>
              <app-date-time-display
                class="calendar-text"
                [datetime]="notification.publishedOn"></app-date-time-display>
            </div>
          </div>
          <motif-card-body class="card-body">
            <div [innerHTML]="notification.sanitizedNotificationText"></div>
          </motif-card-body>
        </motif-card>
      }
    </div>
    <div class="pagination" id="pagination-bottom">
      <app-pagination
        [currentPage]="currentPage()"
        [numberOfPages]="numberOfPages()"
        [numberOfRows]="numberOfRows()"
        [pageSizeOptions]="pageSizeOptions"
        [currentPageSize]="currentPageSize"
        (pageChanged)="pageChanged($event)"
        (pageSizeChanged)="pageSizeChanged($event)">
      </app-pagination>
    </div>
  </div>
</app-page>
